import { GlsSkPickupPoint } from 'skladon-types';

export const formatData = (data: GlsSkPickupPoint[]) => {
    return data.map((item) => ({
        label: `${item.Address} , ${item.CityName}, ${item.ZipCode}, ${item.Name}`,
        value: item.ID
    }));
};
